module.exports = __webpack_public_path__ + "4e45b6f87084cded8967bfc38951bdce.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tag_2x.png
// module id = 32
// module chunks = 0 1 2 3 4